
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#333","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill-rule":"nonzero","d":"M16.667 7C17.403 7 18 7.597 18 8.333v13.334c0 .736-.597 1.333-1.333 1.333H3.333A1.333 1.333 0 012 21.667V8.333C2 7.597 2.597 7 3.333 7H7v1H3.437a.438.438 0 00-.43.359L3 8.438v13.124c0 .242.196.438.438.438h13.124a.438.438 0 00.438-.438V8.438a.438.438 0 00-.438-.437H13V7z"}}),_c('path',{attrs:{"d":"M14.642 4.66l-.707.707-3.45-3.452v14.553h-1V1.915l-3.453 3.45-.707-.707L9.985.001l4.657 4.659z"}})])])
          )
        }
      }
    